import Paragraph from './ui/paragraph';
import AddParagraph from './ui/addParagraph';
import Slide from './ui/slide';

export const Editor = {
  Paragraph,
  AddParagraph,
  Slide,
};
